import { NgModule } from '@angular/core';
import { DefaultLayoutComponent } from './default-layout/default-layout.component';
import { FooterComponent } from './default-layout/footer/footer.component';
import { SharedModule } from '@shared/shared.module';

/**
 * The application shell. The reusable layout chrome (bws-header, bws-sidebar,
 * bws-footer) is declared in SharedModule, because feature templates use it directly.
 */
@NgModule({
  declarations: [
    DefaultLayoutComponent,
    FooterComponent,
  ],
  imports: [
    SharedModule,
  ],
})
export class LayoutsModule { }
